import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  root: {

  }
});

function Graph(props) {
  const { classes } = props;
  return (
    <>
      <div className={classes.root}>
        통계지표 페이지 입니다.
      </div> 
    </>
  );
}
export default withStyles(styles)(Graph);